import { render, staticRenderFns } from "./addOriginal.vue?vue&type=template&id=74e29dec&"
import script from "./addOriginal.vue?vue&type=script&lang=js&"
export * from "./addOriginal.vue?vue&type=script&lang=js&"
import style0 from "./addOriginal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports